/**
 * Fetch a remote resource and convert it to a `File` object.
 *
 * @param url      Source URL of the file.
 * @param filename Desired file name.
 * @param mimeType Mime type for the generated file.
 */
export const urlToFile = async (url: any, filename: any, mimeType = "image/jpeg") => {
  const response = await fetch(url);
  const blob = await response.blob();
  return new File([blob], filename, { type: mimeType });
};

/**
 * Convert a Base64 string to a Blob.
 */
export const base64ToBlob = (base64: any) => {
  const byteString = atob(base64.split(',')[1]);
  const mimeString = base64.split(',')[0].split(':')[1].split(';')[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type: mimeString });
};
/**
 * Convert a `File` to a Base64 encoded string.
 */
export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
};